export default function NotesField({
  label = "Notes for my agent",
  name = "notes",
  value,
  onChange,
  placeholder = "Anything your agent should know about this section…",
  rows = 5,
  className,
}) {
  return (
    <label className={className ? `field ${className}` : "field"}>
      <span className="field-label">{label}</span>
      <textarea
        className="field-textarea field-textarea--tall"
        name={name}
        value={value ?? ""}
        onChange={onChange}
        placeholder={placeholder}
        rows={rows}
      />
    </label>
  );
}
